import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ConfigService} from './config.service';

@Injectable({
  providedIn: 'root'
})

export class LookupTableService {
  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  /**
   * Get list of Lookup table names in GFS
   */
  getLookupTableList(): Observable<string[]> {
    return this.http.get<string[]>(`${this.configService.baseApiUrl}lookup-table`)
    .pipe(catchError(error => this.handleError(error)));
  }

  /**
   * Get data from each Lookup table in the tableList parameter
   * @param tableList list of Lookup table names to get data from
   */
  getLookupTableData(tableList: string[]): Observable<any> {
    return this.http.post<any>(`${this.configService.baseApiUrl}lookup-table`, tableList)
    .pipe(catchError(error => this.handleError(error)));
  }

  /**
   * Loads the lookup tables that the user selects from the Excel file
   * @param file the Excel file that contains look up table info
   * @param sheetList a list containing the selected sheets to read data from
   */
  loadLookupTables(file: File, sheetList: string[], gmid: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('sheets', sheetList.toString());
    formData.append('gmid', gmid);
    return this.http.post<any>(
      `${this.configService.baseApiUrl}lookup-table/load`, formData, {
        reportProgress: true,
        observe: 'events'
      }).pipe(catchError(error => this.handleError(error)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   * @return Observable
   */
  private handleError(errorResponse: HttpErrorResponse): Observable<any> {
    let errorMessage = 'An unexpected error has occurred.';
    if (errorResponse.error && errorResponse.error.message) {
      errorMessage = errorResponse.error.message;
    }
    return throwError(errorMessage);
  }
}
